import React from 'react';
import { Select } from '@material-ui/core';
import './StyledSelect.scss';

const StyledSelect = (props) => (
    <Select
        MenuProps={{
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            getContentAnchorEl: null,
        }}
        variant="outlined"
        className="ss-select-full-width"
        defaultValue=""
        {...props}
    >
        {props.children}
    </Select>
);
export default StyledSelect;